// mutations enums
export enum MutationTypes {
  AUTH_SET_ACCESS_TOKEN = "AUTH_SET_ACCESS_TOKEN",
}

// action enums
export enum ActionTypes {
  AUTH_SET_ACCESS_TOKEN = "AUTH_SET_ACCESS_TOKEN",
}
